import _root_default from "./_root.js";
import _getNative_default from "./_getNative.js";

//#region ../../node_modules/lodash-es/_Promise.js
var Promise$1 = _getNative_default(_root_default, "Promise");
var _Promise_default = Promise$1;

//#endregion
export { _Promise_default as default };
//# sourceMappingURL=_Promise.js.map